<template>
    <div class="codics-aonaer-info-sys-footer">
        Copyright © 2025. All rights reserved. <a href="#">奥纳尔</a> 版权所有 <a href="#">鲁ICP备13020444号-2</a>&nbsp;
        <a href="#">
            <el-image src="https://cdn.bosscaigou.com/huayuan/map/jh.png"
                style="height:16px;width:16px;display: inline-block;vertical-align: middle;margin-top: -3px;" fit="fill"></el-image>&nbsp;鲁公网安备37169102000140号
        </a> 
    </div>
</template>

<script>
export default {

}
</script>

<style>
.codics-aonaer-info-sys-footer {
    height: 53px;
    width: 100%;
    position: fixed;
    bottom: 0;
    border-top: 1px solid rgba(255, 255, 255, .1);
    line-height: 53px;
    text-align: center;
    font-size: 14px;
    color: #FFF;
}

.codics-aonaer-info-sys-footer a{
    color: #FFF !important;
    text-decoration: none !important;
}
</style>